import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "well" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 4,
    style: { "margin-bottom": "30px" }
};
const _hoisted_5 = {
    key: 0,
    class: "supplement"
};
const _hoisted_6 = {
    key: 3,
    class: "editButtons"
};
import { ref, computed } from 'vue';
import MGButton from './MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WellPanel',
    props: {
        title: {},
        subTitle: {},
        icon: {},
        avatarLetter: {},
        data: {},
        editMode: { type: Boolean },
        supplement: {}
    },
    emits: ["merchantClicked", "save"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const newTitle = ref(props.title);
        const sortedData = computed(() => {
            return props.data.slice().sort((a, b) => a.order - b.order);
        });
        function handleClick(d) {
            emit('merchantClicked', d);
        }
        return (_ctx, _cache) => {
            const _component_v_avatar = _resolveComponent("v-avatar");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (!_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.subTitle), 1))
                            : _createCommentVNode("", true),
                        (!_ctx.editMode && _ctx.avatarLetter)
                            ? (_openBlock(), _createBlock(_component_v_avatar, {
                                key: 1,
                                class: "avatar"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.avatarLetter), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (!_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("h1", {
                                key: 2,
                                style: _normalizeStyle(_ctx.supplement ? 'margin-bottom: 5px;' : 'margin-bottom: 30px;')
                            }, _toDisplayString(_ctx.title), 5))
                            : _createCommentVNode("", true),
                        (_ctx.editMode)
                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 3,
                                style: { "margin-bottom": "30px" },
                                class: "wellEditInput",
                                modelValue: newTitle.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((newTitle).value = $event)),
                                placeholder: _ctx.title,
                                flat: true,
                                density: "compact",
                                variant: "solo",
                                "hide-details": "",
                                "single-line": "",
                                "bg-color": 'var(--background-color-main)'
                            }, null, 8, ["modelValue", "placeholder"]))
                            : _createCommentVNode("", true),
                        (!_ctx.editMode && _ctx.supplement)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.supplement), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (!_ctx.data || _ctx.data.length == 0)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_progress_linear, {
                                        height: "2px",
                                        indeterminate: ""
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : (sortedData.value[0].label !== 'No data')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(sortedData.value, (d) => {
                            return (_openBlock(), _createBlock(_component_v_row, {
                                class: _normalizeClass(_ctx.editMode ? 'editMode' : ''),
                                key: d.label,
                                onClick: ($event) => (handleClick(d))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(d.label) + " ", 1),
                                            (d.supplement)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(d.supplement), 1))
                                                : _createCommentVNode("", true),
                                            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                            (_ctx.editMode)
                                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                    key: 1,
                                                    class: "wellEditInput",
                                                    modelValue: d.value,
                                                    "onUpdate:modelValue": ($event) => ((d.value) = $event),
                                                    placeholder: d.value,
                                                    flat: true,
                                                    density: "compact",
                                                    variant: "solo",
                                                    "hide-details": "",
                                                    "single-line": "",
                                                    "bg-color": 'var(--background-color-main)'
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                                                : (_openBlock(), _createElementBlock("span", {
                                                    key: 2,
                                                    class: _normalizeClass({ 'moneyIn': d.moneyIn })
                                                }, _toDisplayString(d.value), 3)),
                                            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                            (d.progress)
                                                ? (_openBlock(), _createBlock(_component_v_row, {
                                                    key: 3,
                                                    class: "progressRow"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_col, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_progress_linear, {
                                                                    "model-value": d.progress,
                                                                    rounded: ""
                                                                }, null, 8, ["model-value"])
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]),
                                                    _: 2
                                                }, 1024))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                _: 2
                            }, 1032, ["class", "onClick"]));
                        }), 128))
                        : _createCommentVNode("", true),
                (_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(MGButton, {
                            alt: "true",
                            small: false,
                            circle: true,
                            icon: "mdi-check",
                            onClick: _cache[1] || (_cache[1] = ($event) => (emit('save', newTitle.value)))
                        })
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
